import createNotification from './createNotification';
import utility from './utility';

const accountNotifications = {
    init: function() {
        const accountSection = document.getElementById("account--landing");
        if (!accountSection) {
            return;
        }

        const editNotificationsButton = document.querySelector("#account--notifications-edit");
        if (editNotificationsButton) {
            editNotificationsButton.onclick = () => {
                this.showNotificationsPopup();
            };
        }

        const showEmailNotifications = document.getElementById("account--notifications-show-email");
        if (showEmailNotifications) {
            showEmailNotifications.onclick = () => {
                this.showEmailNotificationsPopup();
            };
        }

        const showSmsNotifications = document.getElementById("account--notifications-show-sms");
        if (showSmsNotifications) {
            showSmsNotifications.onclick = () => {
                this.showSmsNotificationsPopup();
            };
        }

        const showPushNotifications = document.getElementById("account--notifications-show-push");
        if (showPushNotifications) {
            showPushNotifications.onclick = () => {
                this.showPushNotificationsPopup();
            };
        }

        const editEmailNotificationsForm = document.querySelector("#account--notifications-email-form");
        if (editEmailNotificationsForm) {
            editEmailNotificationsForm.onsubmit = () => {
                this.requestUpdateEmailNotifications();
                return false;
            };
        }

        const editSmsNotificationsForm = document.querySelector("#account--notifications-sms-form");
        if (editSmsNotificationsForm) {
            editSmsNotificationsForm.onsubmit = () => {
                this.requestUpdateSmsNotifications();
                return false;
            };
        }

        const editPushNotificationsForm = document.querySelector("#account--notifications-push-form");
        if (editPushNotificationsForm) {
            editPushNotificationsForm.onsubmit = () => {
                this.requestUpdatePushNotifications();
                return false;
            };
        }
    },

    showNotificationsPopup: function() {
        utility.showPopup(document.querySelector("#account--notifications-popup"));
    },

    showEmailNotificationsPopup: function() {
        accountNotifications.resetSelectedOptions(document.getElementById("account--notifications-email-form"));
        utility.showPopup(document.getElementById("account--notifications-email-popup"));
    },

    requestUpdateEmailNotifications: function() {
        const type = document.querySelector("#account--notifications-email-form input[name='EmailTypeId']:checked");
        if (type && type.value === "L") {
            const checkedCount = document.querySelectorAll("#account--notifications-email-form input[name='EmailLotteyIds']:checked").length;
            if (checkedCount === 0) {
                document.getElementById("account--notifications-email-lottery-error").style.display = "";
                return;
            }
        }
        document.getElementById("account--notifications-email-lottery-error").style.display = "none";

        const ajaxOptions = {
            url: "/api/web/account/update-email-notifications",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--notifications-email-form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    utility.hidePopups();
                    accountNotifications.updateSelectedOptions(document.getElementById("account--notifications-email-form"));
                    createNotification("Your email notification settings have been updated");
                }
            },
            always: function(e) {
                utility.enableButton(document.querySelector("#account--notifications-email-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--notifications-email-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    showSmsNotificationsPopup: function() {
        accountNotifications.resetSelectedOptions(document.getElementById("account--notifications-sms-form"));
        utility.showPopup(document.getElementById("account--notifications-sms-popup"));
    },

    requestUpdateSmsNotifications: function() {
        const type = document.querySelector("#account--notifications-sms-form input[name='SmsTypeId']:checked");
        if (type && type.value === "L") {
            const checkedCount = document.querySelectorAll("#account--notifications-sms-form input[name='SmsLotteryIds']:checked").length;
            if (checkedCount === 0) {
                document.getElementById("account--notifications-sms-lottery-error").style.display = "";
                return;
            }
        }
        document.getElementById("account--notifications-sms-lottery-error").style.display = "none";

        const ajaxOptions = {
            url: "/api/web/account/update-sms-notifications",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--notifications-sms-form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    utility.hidePopups();
                    accountNotifications.updateSelectedOptions(document.getElementById("account--notifications-sms-form"));
                    createNotification("Your SMS notification settings have been updated");
                }
            },
            always: function(e) {
                utility.enableButton(document.querySelector("#account--notifications-sms-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--notifications-sms-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    showPushNotificationsPopup: function () {
        accountNotifications.resetSelectedOptions(document.getElementById("account--notifications-push-form"));
        utility.showPopup(document.getElementById("account--notifications-push-popup"));
    },

    requestUpdatePushNotifications: function () {
        const type = document.querySelector("#account--notifications-push-form input[name='PushTypeId']:checked");
        if (type && type.value === "L") {
            const checkedCount = document.querySelectorAll("#account--notifications-push-form input[name='PushLotteryIds']:checked").length;
            if (checkedCount === 0) {
                document.getElementById("account--notifications-push-lottery-error").style.display = "";
                return;
            }
        }
        document.getElementById("account--notifications-push-lottery-error").style.display = "none";

        const ajaxOptions = {
            url: "/api/web/account/update-push-notifications",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--notifications-push-form")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                if (result.success) {
                    utility.hidePopups();
                    accountNotifications.updateSelectedOptions(document.getElementById("account--notifications-push-form"));
                    createNotification("Your push notification settings have been updated");
                }
            },
            always: function (e) {
                utility.enableButton(document.querySelector("#account--notifications-push-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--notifications-push-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    resetSelectedOptions: function(form) {
        if (form) {
            [...form.querySelectorAll("input")].map(el => {
                if (el.hasAttribute("data-checked")) {
                    el.checked = el.dataset.checked == "1";
                }
            });
        }
    },

    updateSelectedOptions: function(form) {
        if (form) {
            [...form.querySelectorAll("input")].map(el => {
                if (el.hasAttribute("data-parent")) {
                    const parent = document.getElementById(el.dataset.parent);
                    if (parent && !parent.checked) {
                        el.checked = false;
                    }
                }
                if (el.hasAttribute("data-checked")) {
                    el.dataset.checked = el.checked ? "1" : "0";
                }
            });
        }
    }
};

export default accountNotifications;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountNotifications.js